import { SITE_CONFIG } from "../../app/config";
import { useHead, buildBreadcrumbSchema } from "../../seo";
import { comparisons } from "./comparison-data";

export const CompareIndex = (): JSX.Element => {
  useHead({
    title: "Compare Music Formats — Vinyl vs CD vs Streaming",
    description:
      "Side-by-side comparisons of vinyl, CD, streaming, and digital music formats. Sound quality, cost, durability, and which format is right for you.",
    path: "/compare",
    ogType: "website",
    jsonLd: buildBreadcrumbSchema([
      { name: "Home", url: "/" },
      { name: "Compare", url: "/compare" },
    ]),
  });

  return (
    <div className="shell">
      <div className="pseo-page">
        <header className="pseo-header">
          <a href="/" className="blog-back">
            ← Back to {SITE_CONFIG.name}
          </a>
          <h1 className="pseo-title">Compare Music Formats</h1>
          <p className="pseo-subtitle">
            Honest, detailed comparisons to help you decide how to listen to and own your music.
            No bias, just facts and real-world experience.
          </p>
        </header>

        <div className="compare-grid">
          {comparisons.map((comp) => (
            <a
              key={comp.slug}
              href={`/compare/${comp.slug}`}
              className="compare-card"
            >
              <div className="compare-card-vs">
                <span className="compare-card-item">{comp.itemA.name}</span>
                <span className="compare-card-versus">vs</span>
                <span className="compare-card-item">{comp.itemB.name}</span>
              </div>
              <h2 className="compare-card-title">{comp.metaTitle}</h2>
              <p className="compare-card-desc">{comp.metaDescription}</p>
              <span className="compare-card-link">Read comparison →</span>
            </a>
          ))}
        </div>

        <footer className="pseo-footer">
          <div className="blog-cta">
            <h3>Done Comparing? Start Collecting.</h3>
            <p>
              Paste your Spotify playlist and get a shopping list of vinyl & CDs at the best
              prices. Free, instant, no signup required.
            </p>
            <a href="/" className="blog-cta-button">
              Try {SITE_CONFIG.name} →
            </a>
          </div>
          <div className="pseo-nav-links">
            <a href="/glossary">Music Glossary</a>
            <a href="/blog">Blog</a>
            <a href="/">Home</a>
          </div>
        </footer>
      </div>
    </div>
  );
};
